import {sumBy} from 'src/utils/numberUtils';

export const getItemTotal = (item) => item.cost_per_unit * item.total_quantity;
// const sumPurchases = (purchase) => sumBy(purchase.items, getItemTotal);

export const getPurchaseTotalAmount = (purchaseItems) => {
	return sumBy(purchaseItems, getItemTotal);
};
